import { render, staticRenderFns } from "./CkRichEditor.vue?vue&type=template&id=79347051"
import script from "./CkRichEditor.vue?vue&type=script&lang=js"
export * from "./CkRichEditor.vue?vue&type=script&lang=js"
import style0 from "./CkRichEditor.vue?vue&type=style&index=0&id=79347051&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports